import { useEffect } from 'react';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  useIsPrevPageConfirmStore,
  getBtnProps,
  TransitionBtn,
  reloadHandler,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  AccountEstablishRequestParam,
  ComfirmGroup,
  addvanceQuestionParam,
  consentSecuritiesParam,
  consentTrustParam,
  costomerInfoParam,
  depositAccountParam,
  employmentParam,
  investmentInfoParam,
  costomerInfoDispParam,
  depositAccountDispParam,
  employmentDispParam,
  investmentInfoDispParam,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';
import { useOpenAccountMutation, OpenAccountMutationVariables } from 'views/utils/graphql/graphql';
import useOnceSubmit from 'views/utils/useOnceSubmit';
import { useGlobalToastHandler } from 'views/components/organisms/globalToast/hooks';

export const useRequestConfirm = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();
  const { param, add } = useEstablishStore();
  const [openAccountData, openAccount] = useOpenAccountMutation();
  const openAccountParam = useCreateParam(param);
  const comfirmGroup = useCreateDispParam(param, setNowEstablishPageType);
  const { showError } = useGlobalToastHandler();

  const openAccountSubmit = useOnceSubmit<void>(
    {
      onSubmit: async () => {
        const res = await openAccount(openAccountParam);
        if (res.data?.OpenAccount?.Code === 0) {
          setNowEstablishPageType(EstablishPageType.RequestComplete);
        } else if (res.data) {
          showError(res.data.OpenAccount?.Message);
        }

        setIsPrevPageConfirm(false);
      },
    },
    [openAccountParam, showError],
  );

  const { isPrevPageConfirm, setIsPrevPageConfirm } = useIsPrevPageConfirmStore();
  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.OPEN_APPLY, openAccountSubmit);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () => {
    setNowEstablishPageType(EstablishPageType.InvestmentInfo);
    setIsPrevPageConfirm(false);
  });

  useEffect(() => {
    setIsPrevPageConfirm(true);
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.RequestConfirm) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  return {
    isUpdate: false,
    comfirmGroup,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
    },
  };
};

const useCreateParam = (param: AccountEstablishRequestParam): OpenAccountMutationVariables => {
  return {
    input: {
      //事前質問
      ...addvanceQuestionParam(param),
      //証券同意
      ...consentSecuritiesParam(param),
      //信託同意
      ...consentTrustParam(param),
      //お客様情報
      ...costomerInfoParam(param),
      //指定預金口座情報
      ...depositAccountParam(param),
      //お勤め先情報
      ...employmentParam(param),
      //投資情報
      ...investmentInfoParam(param),
    },
  };
};

const useCreateDispParam = (
  param: AccountEstablishRequestParam,
  setNowEstablishPageType: (navType: EstablishPageType) => void,
): ComfirmGroup[] => {
  return [
    costomerInfoDispParam(param, () => setNowEstablishPageType(EstablishPageType.CustomerInfo), false),
    depositAccountDispParam(param, () => setNowEstablishPageType(EstablishPageType.DepositAccount)),
    employmentDispParam(param, () => setNowEstablishPageType(EstablishPageType.Employment)),
    investmentInfoDispParam(param, () => setNowEstablishPageType(EstablishPageType.InvestmentInfo)),
  ];
};
